import { render, staticRenderFns } from "./AthleteScoutingReportsHistory.vue?vue&type=template&id=502cb521&scoped=true&"
import script from "./AthleteScoutingReportsHistory.vue?vue&type=script&lang=ts&"
export * from "./AthleteScoutingReportsHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502cb521",
  null
  
)

export default component.exports